export default __webpack_public_path__ + "static/media/handDown.7396b8a9.svg";